import React, { Children } from 'react';
import { Layout } from '../components/layout/Layout';
export function Privacy() {
  return <Layout data-id="element-751">
      <div className="py-20 bg-white min-h-screen" data-id="element-752">
        <div className="container mx-auto px-4 max-w-3xl" data-id="element-753">
          <h1 className="text-4xl font-bold mb-2" data-id="element-754">Privacy Policy</h1>
          <p className="text-muted-foreground mb-12" data-id="element-755">
            Last updated: February 1, 2026
          </p>

          <div className="prose prose-gray max-w-none space-y-8" data-id="element-756">
            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-757">
              This Privacy Policy explains how Acciom Limited ("FlingLink",
              "we", "us", or "our") collects, uses, discloses, and otherwise
              processes personal information when you use our websites, apps,
              and related services (collectively, the "Service").
            </p>
            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-758">
              If you do not agree with this Privacy Policy, do not use the
              Service.
            </p>

            <section data-id="element-759">
              <h2 className="text-2xl font-bold mb-4" data-id="element-760">Who We Are</h2>
              <p className="text-gray-600 leading-relaxed mb-2" data-id="element-761">
                <strong data-id="element-762">Data Controller:</strong> Acciom Limited (England &
                Wales)
              </p>
              <p className="text-gray-600 leading-relaxed" data-id="element-763">
                <strong data-id="element-764">Contact:</strong>{' '}
                <a href="mailto:help@flinglink.app" className="text-pink-500 hover:underline" data-id="element-765">
                  help@flinglink.app
                </a>
              </p>
            </section>

            <section data-id="element-766">
              <h2 className="text-2xl font-bold mb-4" data-id="element-767">What FlingLink Does</h2>
              <p className="text-gray-600 leading-relaxed" data-id="element-768">
                FlingLink is a connection experience that helps two people
                ("Flings") participate in structured prompts, messaging, and a
                time-boxed journey (including summaries and recaps).
              </p>
            </section>

            <section data-id="element-769">
              <h2 className="text-2xl font-bold mb-4" data-id="element-770">
                Information We Collect
              </h2>
              <p className="text-gray-600 leading-relaxed mb-4" data-id="element-771">
                We collect information you provide, information generated when
                you use the Service, and information from third parties.
              </p>

              <h3 className="text-xl font-semibold mb-3" data-id="element-772">
                Information You Provide
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-gray-600" data-id="element-773">
                <li data-id="element-774">
                  <strong data-id="element-775">Account information:</strong> name, email address,
                  phone number, authentication credentials/tokens, and related
                  sign-in details.
                </li>
                <li data-id="element-776">
                  <strong data-id="element-777">Profile and preferences:</strong> social handles you
                  add, notification preferences, and settings.
                </li>
                <li data-id="element-778">
                  <strong data-id="element-779">Content you create:</strong> messages, prompt
                  responses, notes, audio clips/voice notes, images/media you
                  upload (including report attachments), and other content you
                  submit.
                </li>
                <li data-id="element-780">
                  <strong data-id="element-781">Support communications:</strong> information you
                  provide when you contact us.
                </li>
              </ul>

              <h3 className="text-xl font-semibold mb-3 mt-6" data-id="element-782">
                Information We Collect Automatically
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-gray-600" data-id="element-783">
                <li data-id="element-784">
                  <strong data-id="element-785">Device and usage data:</strong> IP address,
                  device/browser type, app version, pages/screens viewed,
                  actions taken, timestamps, and crash logs.
                </li>
                <li data-id="element-786">
                  <strong data-id="element-787">Cookies/local storage:</strong> used for
                  authentication/session management and core functionality. We
                  may also use analytics tooling (e.g., tag management) to
                  understand usage.
                </li>
              </ul>

              <h3 className="text-xl font-semibold mb-3 mt-6" data-id="element-788">
                Information From Third Parties
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-gray-600" data-id="element-789">
                <li data-id="element-790">
                  <strong data-id="element-791">OAuth/social sign-in providers</strong> (if enabled):
                  limited identifiers (e.g., email, name) depending on what you
                  authorise.
                </li>
                <li data-id="element-792">
                  <strong data-id="element-793">Service providers:</strong> delivery status
                  (SMS/email), fraud signals, or payment confirmation from
                  vendors.
                </li>
              </ul>
            </section>

            <section data-id="element-794">
              <h2 className="text-2xl font-bold mb-4" data-id="element-795">
                Legal Bases for Processing (UK GDPR)
              </h2>
              <p className="text-gray-600 leading-relaxed mb-4" data-id="element-796">
                Where UK data protection law applies, we rely on one or more of
                the following legal bases:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-600" data-id="element-797">
                <li data-id="element-798">
                  <strong data-id="element-799">Contract:</strong> to provide the Service you request
                  (account, prompts, messaging, recaps).
                </li>
                <li data-id="element-800">
                  <strong data-id="element-801">Legitimate interests:</strong> to secure, improve, and
                  operate the Service; prevent abuse; and support users
                  (balanced against your rights).
                </li>
                <li data-id="element-802">
                  <strong data-id="element-803">Consent:</strong> where we ask (e.g., certain
                  notifications/marketing where applicable).
                </li>
                <li data-id="element-804">
                  <strong data-id="element-805">Legal obligation:</strong> where we must comply with
                  law and lawful requests.
                </li>
              </ul>
            </section>

            <section data-id="element-806">
              <h2 className="text-2xl font-bold mb-4" data-id="element-807">
                How We Use Information
              </h2>
              <p className="text-gray-600 leading-relaxed" data-id="element-808">
                We use personal information to provide, operate, maintain, and
                improve the Service; authenticate users and secure accounts;
                enable Flings, prompts, chat, summaries/recaps, and share links
                you generate; send transactional messages and notifications you
                opt into; detect, prevent, and address fraud/abuse; and comply
                with law and enforce our policies.
              </p>
            </section>

            <section data-id="element-809">
              <h2 className="text-2xl font-bold mb-4" data-id="element-810">
                How We Share Information
              </h2>
              <ul className="list-disc pl-6 space-y-2 text-gray-600" data-id="element-811">
                <li data-id="element-812">
                  <strong data-id="element-813">With your Fling:</strong> content and activity within
                  a Fling is shared with the other participant as part of the
                  Service.
                </li>
                <li data-id="element-814">
                  <strong data-id="element-815">With service providers:</strong> we use vendors for
                  hosting, storage, messaging, analytics, payments, and support
                  tooling.
                </li>
                <li data-id="element-816">
                  <strong data-id="element-817">For safety, legal, and compliance:</strong> we may
                  disclose information to protect users, investigate abuse,
                  comply with legal process, or enforce our policies.
                </li>
                <li data-id="element-818">
                  <strong data-id="element-819">Business transfers:</strong> information may be
                  transferred as part of a merger, acquisition, or sale of
                  assets.
                </li>
              </ul>
            </section>

            <section data-id="element-820">
              <h2 className="text-2xl font-bold mb-4" data-id="element-821">
                Summaries/Recaps and Automated Processing
              </h2>
              <p className="text-gray-600 leading-relaxed" data-id="element-822">
                FlingLink may generate summaries, highlights, or "recaps" using
                automated processing (including AI-assisted generation). Inputs
                may include prompt responses, messages, and activity signals
                within a Fling. Outputs are for entertainment/reflection and may
                be inaccurate.
              </p>
            </section>

            <section data-id="element-823">
              <h2 className="text-2xl font-bold mb-4" data-id="element-824">Public/Share Links</h2>
              <p className="text-gray-600 leading-relaxed" data-id="element-825">
                If you generate a share link (e.g., a recap link), anyone with
                the link may be able to view its contents. You are responsible
                for sharing links only with people you trust. Links can be
                forwarded.
              </p>
            </section>

            <section data-id="element-826">
              <h2 className="text-2xl font-bold mb-4" data-id="element-827">Data Retention</h2>
              <p className="text-gray-600 leading-relaxed" data-id="element-828">
                We retain personal information for as long as necessary to
                provide the Service, meet legal obligations, resolve disputes,
                enforce agreements, and maintain safety/integrity. Retention
                periods vary by data type and purpose.
              </p>
            </section>

            <section data-id="element-829">
              <h2 className="text-2xl font-bold mb-4" data-id="element-830">Your Rights (UK)</h2>
              <p className="text-gray-600 leading-relaxed mb-4" data-id="element-831">
                Depending on your circumstances, you may have rights to access,
                correct, delete, restrict/object, portability, and to withdraw
                consent where relevant. To exercise rights, contact{' '}
                <a href="mailto:help@flinglink.app" className="text-pink-500 hover:underline" data-id="element-832">
                  help@flinglink.app
                </a>
                . We may request verification.
              </p>
              <p className="text-gray-600 leading-relaxed" data-id="element-833">
                If you are in the UK, you may complain to the Information
                Commissioner's Office (ICO). We encourage you to contact us
                first so we can try to resolve your concern.
              </p>
            </section>

            <section data-id="element-834">
              <h2 className="text-2xl font-bold mb-4" data-id="element-835">Children</h2>
              <p className="text-gray-600 leading-relaxed" data-id="element-836">
                The Service is not intended for children. You must be at least
                18 (or the age of majority where you live) to use the Service.
              </p>
            </section>

            <section data-id="element-837">
              <h2 className="text-2xl font-bold mb-4" data-id="element-838">Security</h2>
              <p className="text-gray-600 leading-relaxed" data-id="element-839">
                We use reasonable safeguards designed to protect information,
                but no system is 100% secure.
              </p>
            </section>

            <section data-id="element-840">
              <h2 className="text-2xl font-bold mb-4" data-id="element-841">
                International Transfers
              </h2>
              <p className="text-gray-600 leading-relaxed" data-id="element-842">
                Your information may be processed outside your country. Where
                required, we use appropriate safeguards.
              </p>
            </section>

            <section data-id="element-843">
              <h2 className="text-2xl font-bold mb-4" data-id="element-844">Changes</h2>
              <p className="text-gray-600 leading-relaxed" data-id="element-845">
                We may update this Privacy Policy from time to time. If changes
                are material, we will provide notice through the Service.
              </p>
            </section>

            <section data-id="element-846">
              <h2 className="text-2xl font-bold mb-4" data-id="element-847">Contact</h2>
              <p className="text-gray-600 leading-relaxed" data-id="element-848">
                <a href="mailto:help@flinglink.app" className="text-pink-500 hover:underline" data-id="element-849">
                  help@flinglink.app
                </a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </Layout>;
}